import React, { useEffect, useState } from "react";
import { Skeleton } from "@material-ui/core";
import { SimpleSelectOqt, TextOqt, WrapperComponent } from "../..";
import { useDispatch } from "react-redux";
import abmActions from "../../../../redux/actions/abm.actions";

export const FormNodeOperation = ({fmk, formData}) => {

  const dispatch = useDispatch();
  const [ optionsList, setOptionsList ] = useState();

  useEffect(()=>{
    const getSelectList = () => dispatch(abmActions().getTable(`operaciones${formData.parent.id ? `/${formData.parent.id}` : "/0"}`));
    getSelectList().then(response => {
      setOptionsList(response.value)
    })
  }, [dispatch])

  return (
    <>
      <WrapperComponent caption="Nombre" Field={<TextOqt autoFocus name="nombre" formik={fmk} variant="standard"/>}/>
      <WrapperComponent caption="Descripción" Field={<TextOqt name="descripcion" formik={fmk} variant="standard" multiline={true}/>}/>
      {optionsList && 
        <WrapperComponent caption="Operación destino" Field={<SimpleSelectOqt name="idOperacionDestino" formik={fmk} variant="standard" optionsList={optionsList} />}/>
      }
      {!optionsList && 
        <WrapperComponent caption="Operación destino" Field={<Skeleton variant="rectangular" height={52} />}/>
      }
    </>
  )
}